module.exports = __webpack_public_path__ + "static/second-splash-2000x400-656c0bebafbbef10ebdb12972b79870e.jpg";